import styled from '@emotion/styled';
import { StatusTile } from 'components/StatusTile/StatusTile';

export const TraysContainer = styled.div`
  display: flex;
  flex-flow: row wrap;
  width: 100%;
  overflow-y: auto;
`;

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

export const Title = styled.h1`
  margin-left: 1rem;
`;

export const Status = styled(StatusTile)`
  margin-left: 1rem;
`;

export const ButtonContainer = styled.div`
  .MuiButtonBase-root {
    font-size: 14px;
    width: 10rem;
    margin-left: 0.5rem;
    margin-bottom: 0.5rem;
  }
`;
